import { __assign } from 'tslib';
import Vue from 'vue';
import { ADD_FIELD_TO_STATE, SET_FIELD, RESET_STATE } from './form-builder.constants.js';
import { trimWhitespace, getInitialState } from './form-builder.utils.js';

var _a;
var getters = {
    formDataModel: function (state) { return function (stateKey) {
        return state[stateKey];
    }; },
    submitDataModel: function (state) { return function (stateKey) {
        return Object.keys(state[stateKey])
            .filter(function (key) {
            return !state[stateKey][key].hidden &&
                !state[stateKey][key].disabled;
        })
            .reduce(function (acc, key) {
            var _a;
            var _b = state[stateKey][key], type = _b.type, value = _b.value;
            return __assign(__assign({}, acc), (_a = {}, _a[key] = __assign(__assign({}, state[stateKey][key]), { value: getTypedValue(type, value) }), _a));
        }, {});
    }; },
};
function getTypedValue(type, value) {
    if (type === 'text') {
        return value && trimWhitespace(value);
    }
    return value;
}
var actions = {
    /**
     * Gets a form builder configuration object and adds data fields to
     * the store state
     */
    initializeState: function (_a, _b) {
        var commit = _a.commit;
        var stateKey = _b.stateKey, steps = _b.steps;
        var fieldList = getInitialState(steps || []);
        fieldList.forEach(function (field) {
            return commit(ADD_FIELD_TO_STATE, { stateKey: stateKey, field: field });
        });
    },
    setField: function (_a, data) {
        var commit = _a.commit;
        commit(SET_FIELD, data);
    },
    resetState: function (_a, stateKey) {
        var commit = _a.commit;
        commit(RESET_STATE, stateKey);
    },
};
var formBuilder = {
    namespaced: true,
    state: {},
    getters: getters,
    actions: actions,
    mutations: (_a = {},
        _a[ADD_FIELD_TO_STATE] = function (state, _a) {
            var stateKey = _a.stateKey, field = _a.field;
            Vue.set(state[stateKey], field.id, field);
        },
        _a[SET_FIELD] = function (state, _a) {
            var stateKey = _a.stateKey, field = _a.field;
            if (field.id && state[stateKey].hasOwnProperty(field.id)) {
                state[stateKey][field.id] = __assign(__assign({}, state[stateKey][field.id]), field);
            }
        },
        _a[RESET_STATE] = function (state, stateKey) {
            if (!state[stateKey]) {
                Vue.set(state, stateKey, {});
            }
            else {
                Object.keys(state[stateKey]).forEach(function (key) {
                    Vue.delete(state, key);
                });
            }
        },
        _a),
};

export { actions, formBuilder, getters };
